import AV from 'leancloud-storage';
import { authService } from './authService';

export const activityLogService = {
  async logActivity(action, details) {
    try {
      const currentUser = authService.getCurrentUser();
      const username = currentUser ? currentUser.get('username') : '未知用户';
      
      const ActivityLog = AV.Object.extend('ActivityLog');
      const log = new ActivityLog();
      
      log.set({
        user: username,
        userId: currentUser ? currentUser.id : null,
        action,
        details,
        timestamp: new Date()
      });
      
      await log.save();
    } catch (error) {
      console.error('Error logging activity:', error);
      // Don't throw error to prevent disrupting main functionality
    }
  },

  // Helper method to create activity description
  createLogMessage(action, details = '') {
    const currentUser = authService.getCurrentUser();
    const username = currentUser ? currentUser.get('username') : '未知用户';
    return `${username} ${action}${details ? `: ${details}` : ''}`;
  },

  async getActivityLogs(query = {}) {
    try {
      const logQuery = new AV.Query('ActivityLog');
      logQuery.descending('timestamp');
      
      if (query.user) logQuery.equalTo('user', query.user);
      if (query.action) logQuery.equalTo('action', query.action);
      if (query.startDate) logQuery.greaterThanOrEqualTo('timestamp', query.startDate);
      if (query.endDate) logQuery.lessThanOrEqualTo('timestamp', query.endDate);
      
      return await logQuery.find();
    } catch (error) {
      console.error('Error fetching activity logs:', error);
      throw error;
    }
  }
}; 